import { AsYouType, getCountries, getCountryCallingCode, parsePhoneNumberFromString } from "libphonenumber-js";

const PRIMARY_REGIONS = { "1": "US", "7": "RU", "39": "IT", "44": "GB", "47": "NO", "61": "AU", "212": "MA", "262": "RE", "290": "SH", "358": "FI", "590": "GP", "599": "CW" };
const names = new Intl.DisplayNames(["it"], { type: "region" });
export const phoneCountries = getCountries().map((country) => ({ country, name: names.of(country), code: getCountryCallingCode(country) })).sort((a, b) => a.country === "IT" ? -1 : b.country === "IT" ? 1 : a.name.localeCompare(b.name, "it"));
export const countryName = (country) => country ? names.of(country) : "Internazionale";
export const isPhoneField = (key) => /^(phone|phone_number|phonenumber|telefono|cellulare|msisdn|whatsapp|mobile|mobile_number|contact_phone|cliente_cellulare|recipientphone|recipient_phone|senderphone|sender_phone|numero telefonico|numero di telefono)$/i.test(key);

export function phoneParts(value, country = "IT") {
  const raw = String(value ?? "").trim();
  const fallback = phoneCountries.find((item) => item.country === country) || phoneCountries.find((item) => item.country === "IT");
  if (!raw) return { country: fallback.country, code: fallback.code, national: "", full: "", recognized: true };
  if (!/^[+\d\s().-]+$/.test(raw)) return { country: null, code: "", national: raw, full: raw, recognized: false };
  let compact = raw.replace(/[\s().-]/g, "").replace(/^00/, "+");
  let parsed = parsePhoneNumberFromString(compact, fallback.country);
  if (!compact.startsWith("+")) {
    const international = parsePhoneNumberFromString(`+${compact}`);
    if (international?.isValid() && (!parsed?.isValid() || parsed.number.slice(1) === compact)) { compact = `+${compact}`; parsed = international; }
  }
  if (compact.startsWith("+")) {
    const input = new AsYouType(); input.input(compact);
    const code = input.getCallingCode();
    const region = parsed?.country || input.getCountry() || (code === fallback.code ? fallback.country : PRIMARY_REGIONS[code] || phoneCountries.find((item) => item.code === code)?.country);
    if (!code) return { country: null, code: "", national: compact, full: compact, recognized: false };
    return { country: region, code, national: compact.slice(code.length + 1), full: parsed?.isPossible() ? parsed.number : compact, recognized: true };
  }
  const normalized = parsed?.isPossible() ? parsed : null;
  return { country: normalized?.country || fallback.country, code: normalized?.countryCallingCode || fallback.code, national: normalized?.nationalNumber || compact, full: normalized?.number || `+${fallback.code}${compact}`, recognized: true };
}

export function formatPhone(value, country = "IT") {
  const parts = phoneParts(value, country);
  if (!parts.full || !parts.recognized) return { ...parts, text: parts.full || "—" };
  const parsed = parsePhoneNumberFromString(parts.full);
  if (!parsed?.isPossible()) return { ...parts, recognized: false, text: String(value ?? "") || "—" };
  return { ...parts, country: parsed.country || parts.country, text: parsed.formatInternational() };
}

export const phoneSearch = (value) => String(value ?? "").replace(/[^\d]/g, "");
